import React, { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

function LockIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      {...props}
      width="17"
      height="21"
      viewBox="0 0 17 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={twMerge("fill-current", props.className)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 0C6.85761 0 5.52225 0.553123 4.53769 1.53769C3.55312 2.52226 3 3.85761 3 5.25V8.25C2.20435 8.25 1.44129 8.56607 0.87868 9.12868C0.316071 9.69129 0 10.4544 0 11.25V18C0 18.7956 0.316071 19.5587 0.87868 20.1213C1.44129 20.6839 2.20435 21 3 21H13.5C14.2956 21 15.0587 20.6839 15.6213 20.1213C16.1839 19.5587 16.5 18.7956 16.5 18V11.25C16.5 10.4544 16.1839 9.69129 15.6213 9.12868C15.0587 8.56607 14.2956 8.25 13.5 8.25V5.25C13.5 2.35 11.15 0 8.25 0ZM12 8.25V5.25C12 4.25544 11.6049 3.30161 10.9017 2.59835C10.1984 1.89509 9.24456 1.5 8.25 1.5C7.25544 1.5 6.30161 1.89509 5.59835 2.59835C4.89509 3.30161 4.5 4.25544 4.5 5.25V8.25H12Z"
      />
    </svg>
  );
}

const MemoLockIcon = React.memo(LockIcon);
export default MemoLockIcon;
